import styled, { css } from 'styled-components'

export const CardItemContainer = styled.div`
	display: grid;
	grid-template-columns: 60px 1fr 20px;
	padding: 10px;
`
export const InformationContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	width: 100%;
	place-items: start;
`
export const Text = styled.p<{ variant?: boolean }>`
	width: 100%;
	font-size: 0.8rem;

	${({ variant }) =>
		variant &&
		css`
			font-weight: 600;
			margin-bottom: 6px;
		`}
`

export const IconContainer = styled.div<{ color?: string }>`
	path {
		fill: ${({ color }) => color};
	}
`
